import { action, makeObservable, observable } from "mobx";
import BaseMapStore from "./base-map.store";
import { MapMarker } from "./types";

class MapWithMarkersStore extends BaseMapStore {
    markers: MapMarker[] = [];
    bounds?: google.maps.LatLngBounds;

    constructor(center?: google.maps.LatLngLiteral, zoom = 15) {
        super(center, zoom);

        makeObservable(this, {
            markers: observable,
            updateMarkers: action,
        });
    }

    updateMarkers = (value: MapMarker[]) => {
        this.markers = value;

        this.fitBounds();
    }

    fitBounds() {
        if (!this.markers?.length) {
            return;
        }

        let bounds = new google.maps.LatLngBounds();
        // could include selected address too LatLngBounds(this.center);

        this.markers?.forEach((item) => {
            if (!item.position) {
                return;
            }

            bounds = bounds.extend({
                lng: item.position.lng,
                lat: item.position.lat
            });
        });

        this.bounds = bounds;

        if (!this.map) {
            return;
        }

        this.map.fitBounds(bounds);
    }
}

export default MapWithMarkersStore;
